import SelectField from '../../../models/pages/availiableTournaments/FilterField';
import { selectType } from '../../../utils/enum/Enum';
import SeasonsService from '../../../services/main/dictionaries/Season.service';
import type { Translation } from '../../../components/localization/customHooks/Translation';

function getRatingFilterFields(l10n: Translation): SelectField[] {
  return [
    {
      filterName: 'countryId',
      placeHolder: l10n.components.placeholder.ALL_COUNTRIES,
      label: l10n.pages.COUNTRY,
      type: selectType.single,
      items: [],
    },
    {
      filterName: 'seasonId',
      placeHolder: l10n.components.placeholder.ALL_SEASONS,
      label: l10n.pages.SEASON,
      getAvailableItems: SeasonsService.getAsSelectItems,
      type: selectType.single,
    },
    {
      filterName: 'ratingId',
      placeHolder: l10n.components.placeholder.ALL_RATINGS,
      label: l10n.pages.RATING,
      type: selectType.single,
      items: [],
    },
  ];
}

export default getRatingFilterFields;
